var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/AssemblyFilled.tsx";
import React from 'react';
import { createSvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssemblyFilled = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.05",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#00003D"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z",
    fill: "#00003D"
  })]
}), 'AssemblyFilled');